var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "66px",
    viewBox: "0 0 65 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.000000, 8.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    fill: "none",
    id: "Group"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "9.32 13.98 9.32 0.14 31.68 0.14 31.68 13.98"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 9.32,
    y: 29.82,
    width: 22.36,
    height: 12.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32,36.34 L0,36.34 L0,17.27 C0.0109983882,15.4607985 1.48076509,13.9999666 3.29,14 L37.71,14 C39.5192349,13.9999666 40.9890016,15.4607985 41,17.27 L41,36.34 L31.68,36.34",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52,21.43 L10.25,21.43",
    id: "Path"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/print.ce45eb57af36de59f78ed6d40387699f.svg";